// extracted by mini-css-extract-plugin
export default {"openContainer":"GripAnalysisSideBar_openContainer_hzmkB","closeContainer":"GripAnalysisSideBar_closeContainer_jx0Ac","spinAround":"GripAnalysisSideBar_spinAround_Rfyg6"};